import { Button, TooltipDesktop } from '@cian/ui-kit';
import { IconCommunicationComment16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackOpenOfferNote } from './tracking';
import { useOfferContext } from '../../../../context';
import { useAppDispatch } from '../../../../hooks';
import { noteActions, selectIsAuthenticated } from '../../../../slices';
import { ControlWrapper } from 'shared/components/Controls/ControlWrapper';

interface IProps {
  isHovered: boolean;
}

export const NoteControlContainer: React.FC<IProps> = ({ isHovered }) => {
  const { offer, position } = useOfferContext();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const dispatch = useAppDispatch();

  const handleOpenEditing = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      dispatch(noteActions.setIsEditing({ isEditing: true, offer, position }));
      trackOpenOfferNote(offer.id ?? undefined, position);
    },
    [dispatch, offer, position],
  );

  if (!isAuthenticated) {
    return null;
  }

  return (
    <ControlWrapper visible={isHovered}>
      <TooltipDesktop theme="black" placement="left" title="Добавить комментарий">
        <Button
          data-mark="NoteButtonControl"
          theme="stroke_secondary"
          onClick={handleOpenEditing}
          size="XS"
          beforeIcon={<IconCommunicationComment16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
